export default __webpack_public_path__ + "static/media/layout-list-16.0b0ef7d3.svg";